import { getSearchParameters } from "./AppPath";

export const rowsPerPageKey = "frends_rowsPerPage";

const defaultRowsPerPage = 15;

// should this be a hook instead?
export function getRowsPerPage(): number {
    const rowsPerPage = getSearchParameters().pageSize;
    return rowsPerPage || (window?.localStorage?.getItem(rowsPerPageKey) ? Number(window.localStorage.getItem(rowsPerPageKey)) : defaultRowsPerPage);
}

export function setRowsPerPage(rows: number) {
    window.localStorage.setItem(rowsPerPageKey, rows.toString());
}
